module.exports = __webpack_public_path__ + "static/website_icons_v2-04-a5e7cfdbb009df8fcac5000adf52a354.png";